import React from "react";

interface EarthIconProps {
  color?: string;
}

export default function EarthIcon({ color = "#fff" }: EarthIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="Domain" transform="translate(-22.5 -92)">
        <path
          id="Caminho_10335"
          data-name="Caminho 10335"
          d="M14,2A12,12,0,1,0,26,14,12,12,0,0,0,14,2ZM4.4,14a9.634,9.634,0,0,1,.252-2.136L10.388,17.6v1.2a2.407,2.407,0,0,0,2.4,2.4v2.316A9.614,9.614,0,0,1,4.4,14Zm16.668,6.48a2.391,2.391,0,0,0-2.28-1.68h-1.2V15.2a1.2,1.2,0,0,0-1.2-1.2h-7.2V11.6h2.4a1.2,1.2,0,0,0,1.2-1.2V8h2.4a2.407,2.407,0,0,0,2.4-2.4V5.108a9.573,9.573,0,0,1,3.48,15.372Z"
          transform="translate(20.5 90)"
          fill={color}
        />
      </g>
    </svg>
  );
}
